import { createContext, ReactNode, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { createDataCardStore, DataCardStore } from './data-card-store';

type DataCardStoreApi = ReturnType<typeof createDataCardStore>;

export const StoreContext = createContext<DataCardStoreApi | null>(null);

export const DataCardStoreProvider = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<DataCardStoreApi>();
  if (!storeRef.current) {
    storeRef.current = createDataCardStore();
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  );
};

export const useDataCardStoreContext = <T,>(
  selector: (store: DataCardStore) => T,
): T => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error(
      'useDataCardStoreContext must be used within a DataCardStoreProvider',
    );
  }
  return useStore(store, selector);
};
